import React from 'react';

import { ElementWrapper } from '../../../pages/Login/styled';
import { StyledSign } from './styled';

const StepFooter = (): JSX.Element => {
  return (
    <ElementWrapper data-testid="stepFooterWrapper">
      <StyledSign>© 2024 Disney Advertising Sales, LLC. All rights reserved. | V 1.0.0</StyledSign>
    </ElementWrapper>
  );
};

export default StepFooter;
